export const safeRedirect = (url: string, fallback: string = '/dashboard') => {
  try {
    const target = new URL(url, window.location.origin);
    if (
      target.protocol !== 'http:' &&
      target.protocol !== 'https:' &&
      target.protocol !== 'mailto:'
    ) {
      throw new Error('Invalid protocol');
    }
    return target.toString();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return new URL(fallback, window.location.origin).toString();
  }
};
